import { useState } from 'react';
import { Info, ChevronLeft } from 'lucide-react';
import { useAuthContext } from '@core/helpers/client/contexts/AuthContext';
import { openAuthModal } from '@/hooks/useAuthModal';
import ReportProductModal from '@/components/ReportProduct';
import { ProductLabelDescription } from './_productLabel';
import Link from 'next/link';

const ProductNotice = ({ sku, category, noneOrginal, contact, report_model }) => {
    const [reportOpen, setReportOpen] = useState(false);
    const { is_auth } = useAuthContext();

    // گزارش محصول نیاز به ورود دارد: مهمان اول مودال ورود را می‌بیند
    const handleReportClick = () => {
        if (!is_auth) return openAuthModal();
        setReportOpen(true);
    };

    return (
        <>
            <div className="w-full pt-3 lg:pt-8">

                <h2 className='block lg:hidden text-jmt-main font-bold pb-4'>
                    شرایط و مقررات
                </h2>

                {/* sku & report */}
                <div className="flex items-center justify-start lg:pb-4">
                    <button
                        onClick={handleReportClick}
                        className="w-full lg:w-auto flex items-center justify-between lg:justify-start text-jmt-neutral-700 text-xs font-bold cursor-pointer"
                    >
                        <span>گزارش مشخصات محصول یا موارد قانونی</span>

                        <ChevronLeft
                            size={16}
                            className="text-jmt-neutral-700"
                        />
                    </button>

                    {sku ?
                        <div className='hidden lg:block'>
                            <span className="text-xs text-jmt-neutral-500">
                                {sku}
                            </span>
                        </div>
                        : ""}

                </div>

                {sku ?
                    <div className='flex lg:hidden items-center gap-1'>
                        <span className="text-xs text-jmt-neutral-500"> شناسه کالا : </span>
                        <span className="text-xs text-jmt-neutral-500">
                            {sku}
                        </span>
                    </div>
                    : ""}

                {/* labals & description brand & deport */}
                <div className="space-y-4">

                    {/* labals */}
                    <ProductLabelDescription noneOrginal={noneOrginal} />


                    <div className="flex items-start text-jmt-neutral-500 gap-2">
                        <Info size={16} className='shrink-0' />
                        <p className="text-xs whitespace-pre-wrap">
                            {
                                category?.custom_fields?.return_products_text?.length > 0 ?
                                    category?.custom_fields?.return_products_text : <>
                                        درخواست مرجوع کردن محصول در گروه <strong>{category?.title}</strong>  با دلیل "انصراف از خرید" تنها
                                        در صورتی قابل تایید است که محصول در شرایط اولیه ( باز نشدن پلمپ محصول ) باشد .
                                        <br />
                                        برای تکمیل فرایند مرجوعی محصول خود با پشتیبانی تماس حاصل فرمایید:
                                        <a href={`tel:${contact}`} target="_blank" className='font-bold'>{contact}</a>
                                    </>
                            }

                        </p>
                    </div>

                </div>
            </div>

            <ReportProductModal
                open={reportOpen}
                onClose={() => setReportOpen(false)}
                report_model={report_model}
            />
        </>
    );
};

export default ProductNotice;
